module.exports = __webpack_public_path__ + "img/login-3.70d66d7d.jpg";